// extracted by mini-css-extract-plugin
export default {"page__body":"AdminReports_page__body__gCGpQ","page__content":"AdminReports_page__content__aXKm4","MainAdmin_ReportsMainBox":"AdminReports_MainAdmin_ReportsMainBox__aLyQh"};